import { useDispatch, useSelector } from "react-redux";
import { setTokens } from "../User/userSlice";
import { reduxStorage } from "./storage";
import { refreshTokenUser } from "../../api/services"; 
import useNetworkStatus from "./useNetworkStatus";

let isRefreshing = false;
let refreshPromise = null;

const useRefreshToken = () => {
  const dispatch = useDispatch();
  const { tokens } = useSelector((state) => state.user);
  const isOnline = useNetworkStatus(); // ✅ add this

  const refresh = async () => {
    // 🚫 Internet check
    if (!isOnline) {
      console.warn("🚫 No internet - refresh blocked");
      return null;
    }

    if (isRefreshing) return refreshPromise;

    isRefreshing = true;

    refreshPromise = (async () => {
      try {
        console.log("🔥 REFRESH TOKEN CALLED");

        if (!tokens?.refreshToken) {
          throw new Error("No refresh token");
        }

        const response = await refreshTokenUser({
          refreshToken: tokens.refreshToken,
        });

        const newTokens = {
          accessToken: response?.data?.data?.token,
          refreshToken: response?.data?.data?.refreshToken,
        };

        if (!newTokens?.accessToken) {
          throw new Error("Invalid refresh response");
        }

        dispatch(setTokens(newTokens));
        await reduxStorage.setItem("tokens", newTokens);

        return newTokens.accessToken;
      } catch (err) {
        console.error("❌ Refresh failed:", err);
        throw err;
      } finally {
        isRefreshing = false;
      }
    })();

    return refreshPromise;
  };

  return refresh;
};

export default useRefreshToken;